import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { MarketInfo, Reserve } from '@/features/sparklend/common/data/market-info/marketInfo'

export function getReserveEModeCategoryTokens(marketInfo: MarketInfo, reserve: Reserve): TokenSymbol[] {
  const reserveEModeCategoryId = reserve.eModeCategory?.id
  if (reserveEModeCategoryId !== 1 && reserveEModeCategoryId !== 2) return []

  return marketInfo.reserves
    .filter((r) => r.eModeCategory?.id === reserveEModeCategoryId)
    .map((reserve) => reserve.token.symbol)
}
